import React from 'react';
import PropTypes from 'prop-types';

const VerificationStatusPending = ({ size = 80 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 80C39.626 80 39.252 79.9256 38.9007 79.771C37.552 79.2042 6 65.4244 6 37.2692V13.3448L40.9067 1.53557e-08C45.9936 1.73518 74 13.3448 74 13.3448V37.2692C74 65.4244 42.448 79.2042 41.0993 79.7767C40.748 79.9256 40.374 80 40 80Z"
      fill="#D5D7DF"
    />
    <path
      d="M45.94 46.46L48.46 43.94L41.8 37.28V29H38.2V38.72L45.94 46.46ZM40 56C37.51 56 35.17 55.5275 32.98 54.5825C30.79 53.6375 28.885 52.355 27.265 50.735C25.645 49.115 24.3625 47.21 23.4175 45.02C22.4725 42.83 22 40.49 22 38C22 35.51 22.4725 33.17 23.4175 30.98C24.3625 28.79 25.645 26.885 27.265 25.265C28.885 23.645 30.79 22.3625 32.98 21.4175C35.17 20.4725 37.51 20 40 20C42.49 20 44.83 20.4725 47.02 21.4175C49.21 22.3625 51.115 23.645 52.735 25.265C54.355 26.885 55.6375 28.79 56.5825 30.98C57.5275 33.17 58 35.51 58 38C58 40.49 57.5275 42.83 56.5825 45.02C55.6375 47.21 54.355 49.115 52.735 50.735C51.115 52.355 49.21 53.6375 47.02 54.5825C44.83 55.5275 42.49 56 40 56Z"
      fill="white"
    />
  </svg>
);

VerificationStatusPending.propTypes = {
  size: PropTypes.number,
};

export default VerificationStatusPending;
